import ProductStickyBar from './ProductStickyBar';

export default ProductStickyBar;
